import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DataGrid } from '@mui/x-data-grid';

function SearchResultsList(props) {
    const [selection, setSelection] = useState([]);

    const handleSelectionChange = (newSelection) => {
        const matchedObjects = props.data.filter(item => newSelection.includes(item.personId));
        props.onSelectionChanged &&
            props.onSelectionChanged(matchedObjects);
        props.updateDisableAddButton &&
            props.updateDisableAddButton(newSelection.length > 0 ? false : true);
    };

    return (
        <div style={{ width: '100%', height: 400 }}>
            <DataGrid
                rows={props.data?.map(x => { return { id: x.personId, ...x } })}
                columns={[
                    {
                        field: 'displayName',
                        headerName: 'Contact Name',
                        flex: 1,
                    },
                ]}
                multiSelect={false}
                checkboxSelection
                onRowSelectionModelChange={handleSelectionChange}
                autoHeight={true}
                rowHeight={35}
                initialState={{
                    pagination: { paginationModel: { pageSize: 25 } },
                }}
                sx={{
                    backgroundColor: 'white'
                }}
                getRowClassName={(params) => 'grid-row'} />
        </div>
    );
}

SearchResultsList.propTypes = {
    data: PropTypes.array.isRequired,
    onSelect: PropTypes.func,
    onDelete: PropTypes.func,
    onSelectionChanged: PropTypes.func,
    updateDisableAddButton: PropTypes.func,
};

export default SearchResultsList;